// Consent-aware analytics. GA4 loads ONLY after the visitor accepts and only
// when REACT_APP_GA_MEASUREMENT_ID is configured. No analytics otherwise.
export const CONSENT_KEY = "ne-analytics-consent";
export const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return "declined";
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* storage unavailable */
  }
}

export function initAnalytics() {
  if (!GA_ID || getConsent() !== "granted" || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

export function trackEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
}
